
import BigButton from '@/Components/BigButton/BigButton'
import { usePlan } from '@/Hooks/UsePlan'
import useTranslation from '@/Hooks/UseTranslation'
import ProjectsActions from '@/Redux/Actions/ProjectsActions'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'

const OtherProjects = () => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const {
    tooManyOthersProjects,
    tooManyActiveProjects,
    showTooManyOthersProjectsModal,
  } = usePlan()

  const { other: otherProjects } = useSelector((state: any) => state.ProjectsReducer.data)

  const isDisabled = (project: any) => {

      if (project.deleting) return true

      if (project.isMine)
          return tooManyActiveProjects

      return tooManyOthersProjects
  }

  const handleAbandonOthersProject = async (project_id: string) => {

    const result = await Swal.fire({
      title: t('HOME:AbandonOthersProject-title'),
      text: t('HOME:AbandonOthersProject-content'),
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: t('HOME:AbandonOthersProject-cancel'),
      confirmButtonText: t('HOME:AbandonOthersProject-accept'),
      width: '500px',
    })

    if (result.isConfirmed) {

      dispatch(ProjectsActions.abandonAction(project_id))
    }
  }

  return (
    <Row className='mb-4'>
      {otherProjects.map((project: any, i: number) => (
        <Col key={i} xl={2} lg={3} md={4} className="mb-3">
          <BigButton
            icon="icon-otros_proyectos"
            text={project.shortName}
            to={`/project/${project._id}`}
            altButtonClick={() => handleAbandonOthersProject(project._id)}
            onDisabledClick={() => {

              if (tooManyOthersProjects)
                showTooManyOthersProjectsModal(t('HOME:TooManyProjectsYouAreParticipatingIn-title'))
            }}
            disabled={isDisabled(project)}
          />
        </Col>
      ))}
    </Row>
  )
}

export default OtherProjects
